import { getEnvConfig } from './envConfig';
import { isNullOrWhitespace } from "./StringPolyfil";

const envConfig = getEnvConfig();

export const AppManifest = {
  Environment: envConfig.Environment,
  EnvironmentMoniker: !isNullOrWhitespace(envConfig.Environment) && !/PRD/i.test(envConfig.Environment) ? `[${envConfig.Environment?.toUpperCase()}] ` : '',
  Hostname: envConfig.Hostname,  
  LastPublishedOn: envConfig.LastPublishedOn,
  Version: envConfig.InfoVersion,
  Authors: envConfig.InfoAuthors,
  AuthorsEmail: envConfig.InfoAuthorsEmail,
  Company: envConfig.InfoCompany,
  Copyright: envConfig.InfoCopyright,
  BackendApiUrl: envConfig.BackendApiUrl
};
